import React from 'react'

import { useTranslation } from 'react-i18next'
import { BuildingEnergyRatingType } from '../../../../../../@types/types'

export type GetThermalCharacteristicInputLabelProps = {
  buildingEnergyRatingType?: BuildingEnergyRatingType
}

const GetThermalCharacteristicInputLabel: React.FC<GetThermalCharacteristicInputLabelProps> = ({
  buildingEnergyRatingType,
}) => {
  const { t } = useTranslation()

  let thermalCharacteristicInputLabel = ''
  if (buildingEnergyRatingType === BuildingEnergyRatingType.ENERGY_REQUIRED) {
    thermalCharacteristicInputLabel = t('wizard.screen.construction.finalEnergy', 'Final energy')
  }
  if (buildingEnergyRatingType === BuildingEnergyRatingType.ENERGY_CONSUMPTION) {
    thermalCharacteristicInputLabel = t('wizard.screen.construction.energyConsumption', 'Energy consumption')
  }

  return <span>{thermalCharacteristicInputLabel}</span>
}

export default GetThermalCharacteristicInputLabel
